import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 84px;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;
